import React from 'react';
import {hydrate, render} from 'react-dom';

import 'katex/dist/katex.min.css';

import './index.css';
import App from './App';


const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
  hydrate(<App/>, rootElement);
} else {
  render(<App/>, rootElement);
}

/* Do not register service worker due to cache issues */
//import registerServiceWorker from './registerServiceWorker';
//registerServiceWorker();
